/** Cycle total shown with remaining. Starting amount wins; program budget is the fallback. */
export const cycleDisplayBudget = (program: {
  budget?: number | null
  startingBudget?: number | null
}): number => {
  const programBudget = program.budget ?? 0
  if (program.startingBudget == null) return programBudget
  return program.startingBudget
}

/** Starting amount is present and below the card program budget. */
export const isProratedBudget = (program: {
  budget?: number | null
  startingBudget?: number | null
}): boolean => {
  const programBudget = program.budget ?? 0
  return (
    program.startingBudget != null && program.startingBudget < programBudget
  )
}

export const PRORATED_BUDGET_TIP =
  'Prorated for joining after this cycle started. Full amount will be granted next cycle.'
